import { useQuery } from "react-query"
import { AxiosResponse } from "axios"

import employeesService from "../employeesService"

export interface IEmployeeRole {
  id: string
  name: string
  usersCount: number
}

export interface IEmployeeRolesRes {
  data: IEmployeeRole[]
}

const useGetEmployeeRoles = (enabled?: boolean) => {
  return useQuery("employee-roles", async () => {
    try {
      const res: AxiosResponse<any> =
        await employeesService.getEmployeeRoles()

      return res.data.data
    } catch (err: any) {
      return err.response
    }
  }, { refetchOnWindowFocus: false, enabled })
}

export default useGetEmployeeRoles
